import MainLayout from "../features/mainLayout/MainLayout";

const Home = () => <MainLayout />;

export default Home;
